import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_27 = { class: "dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "" }
const _hoisted_33 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_34 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_38 = { class: "fw-bold" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "mt-15 mt-md-0" }
const _hoisted_41 = { class: "pagination mb-0" }
const _hoisted_42 = {
  key: 0,
  class: "page-item"
}
const _hoisted_43 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 1,
  class: "page-item"
}
const _hoisted_46 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-header" }
const _hoisted_50 = { class: "modal-title fs-5" }
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { style: {} }
const _hoisted_53 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_56 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_60 = { style: {"color":"#FFF"} }
const _hoisted_61 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_62 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-header" }
const _hoisted_65 = { class: "modal-title fs-5" }
const _hoisted_66 = { class: "modal-body" }
const _hoisted_67 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_68 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_69 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_70 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_71 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_72 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = ["placeholder"]
const _hoisted_77 = { class: "invalid-feedback" }
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "invalid-feedback" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_85 = ["placeholder"]
const _hoisted_86 = { class: "invalid-feedback" }
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_89 = ["selected"]
const _hoisted_90 = ["selected"]
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-md-12" }
const _hoisted_93 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_94 = { value: "" }
const _hoisted_95 = ["value"]
const _hoisted_96 = { class: "modal-footer" }
const _hoisted_97 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_98 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Business } from "@/utils/Model";

import { current_permissions } from '../../utils/permission';
import { validate_phone_number, showToast, checkSessionValidate } from "@/utils/function";


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessContent',
  setup(__props) {

const backApi = inject('back');
const btnLoad = ref(true);
const { t } = useI18n();
const selectedValidation = ref('N');
const selectedCategory = ref('');

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let role: string | null = localStorage.getItem('role');

// Toutes les lignes reçues du back
const allBusiness = ref(new Array<Business>());
const categories = ref(new Array<Business>());
let edit = 0;
let itemCode = '';

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const statusLabelOf = (status: boolean) =>
  status === false ? t('business.no') : t('business.yes');

const filteredBusiness = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allBusiness.value;
  return allBusiness.value.filter((b: any) => {
    const values = [
      b.code,
      b.organization?.name,
      b.name,
      b.description,
      b.maxPayoutAmount,
      b.payinBalance,
      b.payoutBalance,
      statusLabelOf(b.validatePayoutBeforProcess),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredBusiness.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const paginatedBusiness = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredBusiness.value.slice(start, start + pageSize.value);
});

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'name': '', 'description': '', 'maxAmount': 0 };
const pageLoad = ref(false);

const formValues = reactive({
  name: "",
  description: "",
  maxAmount: 0
});

const schema = yup.object({
  name: yup.string().required('Le nom est requis'),
  description: yup.string().required('La description est requise'),
  maxAmount: yup.number().required('Le montant maximum est requis'),
});

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleCategoryChange(event) {
  selectedCategory.value = event.target.value;
}

const initField = () => {
  formValues.name = '';
  formValues.description = '';
  formValues.maxAmount = 0;
  selectedValidation.value = 'N';
  edit = 0;
  errors.value = '';
  errorId.value = '';
  success.value = '';
}

const fetchBusinessPage = (targetPage: number) => {
  let baseUrl = '';
  if (role === 'SUPERADMIN') {
    baseUrl = `${backApi}/secure/business`;
  } else {
    baseUrl = `${backApi}/secure/business?organization=${codeOrganization}`;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}currentPage=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllBusiness = async () => {
  try {
    const first = await fetchBusinessPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchBusinessPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allBusiness.value = collected;
    data = collected;
    page.value = 1;
    console.log('Business chargés:', collected.length);
  } catch (error: any) {
    console.error('Erreur chargement business:', error);
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getBusinessParent = (arg = 1) => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `&organization=${codeOrganization}`;
  
  axios.get(backApi + '/secure/business?currentPage=' + arg + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    categories.value = response.data.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showBusiness = (code) => {
  axios.get(backApi + '/secure/business/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.name = response.data.name;
    formValues.description = response.data.description;
    formValues.maxAmount = response.data.maxPayoutAmount;
    selectedValidation.value = (response.data.validatePayoutBeforProcess) ? 'O' : 'N';
    itemCode = response.data.code;
    edit = 1;
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const showScreen = (code) => {
  itemCode = code;
  errors.value = '';
  errorId.value = '';
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeBusiness()
  } else {
    updateBusiness()
  }
}

const storeBusiness = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/business/new`, {
      name: formValues.name,
      description: formValues.description,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      maxPayoutAmount: formValues.maxAmount,
      organization: codeOrganization,
      parent: selectedCategory.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        loadAllBusiness(); // Recharger les données
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateBusiness = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    
    axios.put(`${backApi}/secure/business/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      maxPayoutAmount: formValues.maxAmount,
      organization: codeOrganization,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        loadAllBusiness(); // Recharger les données
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteBusiness = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/business/delete`, { headers, data })
      .then(response => {
        if (response.status === 200) {
          btnLoad.value = true;
          showToast("Suppression effectuée avec succès", "green");
          loadAllBusiness();
          // Fermer la modale
          const modal = document.getElementById('filterLeadModal');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1);
  await loadAllBusiness();
  getBusinessParent();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('business.search')
              }, null, 8, _hoisted_5), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(current_permissions)('create_business', 'edit_business'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('business.addBusiness')) + " ", 1),
                    _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('business.code')), 1),
                    (_unref(current_permissions)('SUPERADMIN'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_ctx.$t('business.organization')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('business.name')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('business.description')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('business.maxAmount')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('business.validation')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('business.collectBalance')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('business.transferBalance')), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedBusiness.value, (businessItem) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: businessItem.code
                    }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(businessItem.code), 1),
                      (_unref(current_permissions)('SUPERADMIN'))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(businessItem.organization?.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(businessItem.name), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(businessItem.description), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(businessItem.maxPayoutAmount), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString((businessItem.validatePayoutBeforProcess==false) ? _ctx.$t('business.no') : _ctx.$t('business.yes')), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(businessItem.payinBalance || 0), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(businessItem.payoutBalance || 0), 1),
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _cache[18] || (_cache[18] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_28, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('delete_business'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    style: {"color":"red"},
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#filterLeadModal",
                                    onClick: ($event: any) => (showScreen(businessItem.code))
                                  }, [
                                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('business.delete')), 1)
                                  ], 8, _hoisted_29))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('edit_business'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showBusiness(businessItem.code))
                                  }, [
                                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('business.edit')), 1)
                                  ], 8, _hoisted_31))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (filteredTotal.value>pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                        _createTextVNode(_toDisplayString(_ctx.$t('business.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('business.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('business.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                        _createTextVNode(_toDisplayString(_ctx.$t('business.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('business.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('business.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_40, [
                    _createElementVNode("ul", _hoisted_41, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_43, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (goToPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_44))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h1", _hoisted_50, _toDisplayString(_ctx.$t('business.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              (errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_53, _toDisplayString(_ctx.$t('business.confirmDelete')), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("h6", _hoisted_55, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_56, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('business.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteBusiness()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_59))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('business.yes')), 1)
            ], 8, _hoisted_58)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("h1", _hoisted_65, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('business.addBusiness') : _ctx.$t('business.editBusiness')), 1),
              _cache[21] || (_cache[21] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_66, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("h6", _hoisted_68, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_69, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("h6", _hoisted_71, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('business.businessName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('business.businessNamePlaceholder'),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.name) = $event)),
                        id: "name",
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_76), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_77, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('business.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        placeholder: _ctx.$t('business.descriptionPlaceholder'),
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formValues.description) = $event)),
                        id: "description",
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_80), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('business.maxAmount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['maxAmount'] }]),
                        placeholder: _ctx.$t('business.maxAmountPlaceholder'),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formValues.maxAmount) = $event)),
                        id: "maxAmount",
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (validate('maxAmount'))),
                        onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target,12)))
                      }, null, 42, _hoisted_85), [
                        [_vModelText, formValues.maxAmount]
                      ]),
                      _createElementVNode("span", _hoisted_86, _toDisplayString(errorsBis['maxAmount']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('business.requiresValidation')), 1),
                    _createElementVNode("select", {
                      name: "operator",
                      id: "operator",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleValidationChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "N",
                        selected: selectedValidation.value === 'N'
                      }, _toDisplayString(_ctx.$t('business.no')), 9, _hoisted_89),
                      _createElementVNode("option", {
                        value: "O",
                        selected: selectedValidation.value === 'O'
                      }, _toDisplayString(_ctx.$t('business.yes')), 9, _hoisted_90)
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t('business.category')), 1),
                    _createElementVNode("select", {
                      name: "business",
                      id: "business",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCategoryChange
                    }, [
                      _createElementVNode("option", _hoisted_94, _toDisplayString(_ctx.$t('business.selectCategory')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: category.code,
                          key: category.code
                        }, _toDisplayString(category.name), 9, _hoisted_95))
                      }), 128))
                    ], 32)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_96, [
              (_unref(current_permissions)('create_business', 'edit_business'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_97, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_98))
                      : _createCommentVNode("", true),
                    _cache[22] || (_cache[22] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('business.save') : _ctx.$t('business.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})